import { createAction } from 'lib/store-utils';
import { EventsGetSuccess, EventResponse } from '../types';

export const BOX_EVENTS_GET_SUCCESS = createAction<EventsGetSuccess>('Events / get success');
export const BOX_EVENTS_UPDATED = createAction<EventResponse>('Events / updated');
export const BOX_EVENTS_UPDATE_ADD_ONE = createAction<EventResponse>('Events / update/add one');
export const BOX_EVENTS_DELETE_ONE = createAction<string>('Events/ event remove from list');
